import { Outlet } from 'react-router-dom';
import { AuthProvider } from '../context/AuthContext';

export const RootLayout = () => {
  return (
    <AuthProvider>
      <div className="min-h-screen bg-slate-50 font-sans text-slate-900 antialiased">
        <Outlet />
      </div>
    </AuthProvider>
  );
};
